import axios from 'axios'
import Qs from 'qs'
import router from '@/router'
import weui from 'weui.js'
/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */


// const tip = (msgcont) => {
//   weui.alert(msgcont, {
//     title: '温馨提示',
//     buttons: [{
//         label: '确定',
//         type: 'primary',
//         onClick: function(){ console.log('ok') }
//     }]
// });
// }

/**
 * 请求失败后的错误统一处理
 */
const errorHandle = (response, other) => {
    console.log(response);
    
    // 状态码判断
    let errMsg = ''
    if (response.data.state !== undefined && response.data.state.stateMessage !== null) {
        errMsg = response.data.state.stateMessage.toString()
    }
    if (errMsg !== undefined && (typeof errMsg === 'string' && errMsg.length === 0)) {
        errMsg = '网络错误，请稍后再试'
    }
    // tip(errMsg)
    console.log(errMsg,' // 状态码判断')
}
// 创建axios实例 超时时间30s
var instance = axios.create({

    timeout: 3000 * 10,
})
// 测试
// 设置默认请求头http://gzhhqf.ebopencloud.com
instance.defaults.headers = {}//http://micropush.ebopencloud.com/app/article/annualBill?phoneNumber=2ee90ff0be7049318cdd59923610676e
// instance.defaults.baseURL = 'http://micropush.ebopencloud.com'
instance.defaults.baseURL = 'http://gzhhqf.ebopencloud.com'
// http request 拦截器
instance.interceptors.request.use(config => {
    // 创建合同需要发送json表单
    // if (config.url.indexOf('/house/attract_invest/create') !== -1 || config.url.indexOf('/user1/userfinal') !== -1 || config.url.indexOf('/contract/create') !== -1 || config.url.indexOf('/contract/update') !== -1 || config.url.indexOf('/customer/create') !== -1 || config.url.indexOf('/customer/update') !== -1) {
    //     config.data = JSON.stringify(config.data)
        config.headers = {
            'Content-Type': 'application/json'
        }
    // } else {
    //     config.data = Qs.stringify(config.data)
        // config.headers = {
        //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        // }
    // }
    return config
}, error => {
    return Promise.reject(error)
})
// http response 拦截器
instance.interceptors.response.use(response => {
    if (response) {
        // http status 200请求成功
        if (response.status === 200) {
            // 自定义状态码0为成功
            if (response.data.state !== undefined && response.data.state.stateCode === 0) {
                // 成功
                console.log(response.data,'自定义状态码0为成功')
                return Promise.resolve(response.data)
            } else {
                // 失败
                errorHandle(response)
                return Promise.resolve(response.data)
            }
        } else {
            // tip('Error: ' + response.status)
            return Promise.reject(response)
        }
    } else {
        // 全网设置超时时间
        // tip('网络错误')
        console.log('网络错误  ===  response 拦截器')
        return Promise.reject(response)
    }
}, error => {
    console.log(error,'999999900000')
    // const responseCode = error.response.status
    const responseCode = error.response

    console.log(responseCode,'error.response')
    switch (responseCode) {
        // 400 参数异常
        case 400:
            // tip('参数异常')
            console.log('参数异常  ===  response 拦截器')
            break
        // 401：未登录
        case 401:
            // 跳转登录页
            //tip('登录信息过期，请重新登录')
            sessionStorage.clear()
            // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
            toLogin()
            break
        // 403: token过期
        case 403:
            // 弹出错误信息
            // tip('无访问权限！')
            break
        default:
            // 其他错误，直接抛出错误提示
            // tip('网络错误')
    }
    return Promise.reject(error)
})
const toLogin = () => {
    router.replace({
        name: 'Login',
        query: {
            toName: router.currentRoute.name,
            isReplace: true
        }
    })
}
export default instance


// WEBPACK FOOTER //
// ./src/request/http.js